import React from "react";
import { CellProps } from "react-table";
import { InspectionData } from "../constants/CitizenInspection";

export default function InspectionApplicationCell({ cellProps }: { cellProps: CellProps<InspectionData> }) {
  const permit = cellProps.row.original.permit;
  const permitTypeName = permit?.type?.name;

  // Select the formal number or reservation number, reservation number takes priority
  const confirmationNumber = permit?.confirmationNumber;
  const reservationNumber = permit?.reservationNumber;
  const formalNumber = reservationNumber ? reservationNumber : confirmationNumber?.match(/.{3}/g)?.join("-");

  return (
    <>
      {permitTypeName}
      <p className='subText'>{formalNumber}</p>
    </>
  );
}
